
// REACT
import { useContext } from "react";

// ASSETS
import languagePack from "../assets/languages/languagePack";

// COMPONENTS
import ToolHeader from "../components/common/ToolHeader";
import ProductsList from "../components/productManager/ProductsList";

// CONTEXT
import { maincontext } from "../context/maincontext";


export default function Productmanager() {
    const {language} = useContext(maincontext)
    
    return (
        <>
            <ToolHeader 
            toolHeader={languagePack[language].productManager.title}
            icon={"products"}
            
            />
            <div>
                <ProductsList />
            </div>
        </>
    )
}